import React, { useEffect, useState } from 'react';
import { getMyInvites, acceptInvite, rejectInvite } from '../lib/api';
import { Building, Check, X } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

export function InviteHandler() {
  const [invites, setInvites] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);
  const [actionLoading, setActionLoading] = useState<string | null>(null);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchInvites = async () => {
      const token = localStorage.getItem('access_token');
      if (!token) {
        setLoading(false);
        return;
      }
      
      try {
        const pendingInvites = await getMyInvites();
        setInvites(pendingInvites);
      } catch (error) {
        console.error("Failed to fetch invites", error);
      } finally {
        setLoading(false);
      }
    };

    fetchInvites();
  }, [navigate]);

  const handleAccept = async (inviteId: string) => {
    setActionLoading(inviteId);
    try {
      await acceptInvite(inviteId);
      setInvites(invites.filter(i => i.id !== inviteId));
      window.location.reload(); // Refresh the app to load new company context
    } catch (error: any) {
      alert(error.message || 'Davet kabul edilemedi');
    } finally {
      setActionLoading(null);
    }
  };

  const handleReject = async (inviteId: string) => {
    setActionLoading(inviteId);
    try {
      await rejectInvite(inviteId);
      setInvites(invites.filter(i => i.id !== inviteId));
    } catch (error: any) {
      alert(error.message || 'Davet reddedilemedi');
    } finally {
      setActionLoading(null);
    }
  };

  if (loading || invites.length === 0) return null;

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center p-4 bg-black/60 backdrop-blur-sm">
      <div className="bg-[#1a1a1a] rounded-xl border border-white/10 w-full max-w-md shadow-2xl overflow-hidden animate-in fade-in zoom-in-95 duration-200">
        <div className="p-6 text-center border-b border-white/5">
          <div className="w-16 h-16 bg-blue-500/10 rounded-2xl flex items-center justify-center mx-auto mb-4 border border-blue-500/20">
            <Building className="w-8 h-8 text-blue-500" />
          </div>
          <h2 className="text-xl font-bold text-white mb-2">Şirket Daveti</h2>
          <p className="text-gray-400 text-sm">
            Size bir veya daha fazla şirkete katılma daveti gönderildi. Lütfen aşağıdaki davetleri inceleyin.
          </p>
        </div>
        
        <div className="max-h-64 overflow-y-auto p-4 space-y-3">
          {invites.map(invite => (
            <div key={invite.id} className="bg-[#252525] border border-white/5 rounded-lg p-4 flex flex-col gap-3">
              <div>
                <h3 className="text-white font-medium">{invite.companyName}</h3>
                <p className="text-gray-400 text-xs mt-1">
                  Rol: <span className="text-gray-300 font-medium capitalize">{invite.role}</span>
                </p>
                <p className="text-gray-500 text-xs mt-1">
                  Tarih: {new Date(invite.invitedAt).toLocaleDateString('tr-TR')}
                </p>
              </div>
              
              <div className="flex gap-2 pt-2 border-t border-white/5">
                <button
                  onClick={() => handleAccept(invite.id)}
                  disabled={actionLoading !== null}
                  className="flex-1 flex items-center justify-center gap-1.5 px-3 py-2 bg-green-600 hover:bg-green-700 text-white text-xs font-medium rounded-md transition-colors disabled:opacity-50"
                >
                  {actionLoading === invite.id ? (
                    <div className="w-3.5 h-3.5 border-2 border-white/30 border-t-white rounded-full animate-spin"></div>
                  ) : (
                    <Check className="w-3.5 h-3.5" />
                  )}
                  Kabul Et
                </button>
                <button
                  onClick={() => handleReject(invite.id)}
                  disabled={actionLoading !== null}
                  className="flex-1 flex items-center justify-center gap-1.5 px-3 py-2 bg-white/5 hover:bg-white/10 text-gray-300 text-xs font-medium rounded-md transition-colors disabled:opacity-50"
                >
                  <X className="w-3.5 h-3.5" />
                  Reddet
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
